import axios, { AxiosError, AxiosResponse } from 'axios'
import { BASE_API_URL, LOGIN_ENDPOINT } from './api'
import { getUserDevice } from './userDevice'

export const affiliateLogin = (params: {
  email: string
  password: string
}): Promise<any> => {
  const { email, password } = params
  return axios
    .post(`${BASE_API_URL}${LOGIN_ENDPOINT}`, {
      email,
      password,
      userDevice: getUserDevice(),
    })
    .then((response: AxiosResponse) => response.data)
    .catch((err: AxiosError) => {
      if (err.response) return err.response.data
      return err
    })
}
